export default {
  data() {
    return {
      localizedEthnicities: [
        {
          key: 1,
          value: 'message.ethnicityWhite'
        },
        {
          key: 2,
          value: 'message.ethnicityArab'
        },
        {
          key: 3,
          value: 'message.ethnicityIndian'
        },
        {
          key: 4,
          value: 'message.ethnicityPakistani'
        },
        {
          key: 5,
          value: 'message.ethnicityBangladeshi'
        },
        {
          key: 6,
          value: 'message.ethnicityChinese'
        },
        {
          key: 7,
          value: 'message.ethnicityOtherAsian'
        },
        {
          key: 8,
          value: 'message.ethnicityBlack'
        },
        {
          key: 9,
          value: 'message.ethnicityOther'
        },
        {
          key: 10,
          value: 'message.ethnicityRatherNotSay'
        }
      ]
    }
  },
  methods: {
    localizeEthnicity(key) {
      let self = this;
      return self.localizedEthnicities.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Ethnicity/index.js